export default function DetectPreferredColorSchema(): "light" | "dark"{
  const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches
  return isDarkMode ? "dark" : "light"
}